import React from "react";
import '../experience/Experience.css'
import { FaHtml5 } from "react-icons/fa";
import { FaCss3Alt } from "react-icons/fa";
import { TbBrandJavascript } from "react-icons/tb";
import { SiTailwindcss } from "react-icons/si";
import { FaSass } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { SiRedux } from "react-icons/si";
import { SiTypescript } from "react-icons/si";


function Experience() {
    return(
        <>
        <h2 className="page">My Experience</h2>
        <div className="experiences flex justify-center items-center text-white bg-gradient-to-r from-[#3b82f652] m-auto w-fit">
            <div className="lift">
                <div className="corcess">
                    <div className="name">
                      <FaHtml5 className="icoon"/>
                      <h2>HTML/5</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <FaCss3Alt className="icoon"/>
                      <h2>CSS/3</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <FaSass className="icoon"/>
                      <h2>SASS</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <SiTailwindcss className="icoon"/>
                      <h2>Tailwindcss</h2>
                    </div>
                    <p>Experienced</p>
                </div>
            </div>
            <div className="right">
                <div className="corcess">
                    <div className="name">
                      <TbBrandJavascript className="icoon"/>
                      <h2>JavaScript</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <FaReact className="icoon"/>
                      <h2>React</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <SiRedux className="icoon"/>
                      <h2>Redux</h2>
                    </div>
                    <p>Experienced</p>
                </div>
                <div className="corcess">
                    <div className="name">
                      <SiTypescript className="icoon"/>
                      <h2>Typescript</h2>
                    </div>
                    <p>Experienced</p>
                </div>
            </div>
        </div>
        </>
    )
}

export default Experience;